import React from "react";
import SpikeStatsCard from "./SpikeStatsCard";

function ChipIcon({ type }) {
  const s = { fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" };
  if (type === "zones") return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="7" {...s} />
      <circle cx="12" cy="12" r="3" {...s} />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2" {...s} />
    </svg>
  );
  if (type === "filter") return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 6h16l-6 7v5l-4-2v-3L4 6Z" {...s} />
    </svg>
  );
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 17h8l-1.2-1.8V11a4.8 4.8 0 1 0-9.6 0v4.2L8 17Z" {...s} />
      <path d="M10.5 19a1.7 1.7 0 0 0 3 0" {...s} />
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.2"
      strokeLinecap="round" strokeLinejoin="round" className="landing-btn-arrow"
      width="16" height="16" aria-hidden="true">
      <path d="M4 10h12M11 5l5 5-5 5" />
    </svg>
  );
}

export default function Hero({ onSignup, onViewDashboard, onLogin, isAuthenticated }) {
  return (
    <section className="landing-hero" id="top">
      <div className="landing-hero-copy">
        <div className="landing-live-badge">
          <span className="landing-live-dot" />
          Live · Boom &amp; Crash Markets
        </div>

        <h1 className="landing-hero-title">
          Catch Market<br />
          <span className="landing-title-gradient">Moves with Precision</span>
        </h1>

        <p className="landing-hero-subtitle">
          Zone-based trading intelligence built for Boom &amp; Crash markets.
          Read structure, spot fresh zones, and stay prepared when price moves.
        </p>

        <div className="landing-hero-chips">
          <span className="landing-chip landing-chip-blue">
            <ChipIcon type="zones" />
            Real-time Zone Detection
          </span>
          <span className="landing-chip landing-chip-green">
            <ChipIcon type="filter" />
            Smart Zone Filtering
          </span>
          <span className="landing-chip landing-chip-orange">
            <ChipIcon type="bell" />
            Instant Price Alerts
          </span>
        </div>

        <div className="landing-hero-actions">
          <button type="button" className="landing-primary-button" onClick={onSignup}>
            Start 7-Day Free Trial
            <ArrowIcon />
          </button>
          <button type="button" className="landing-secondary-button" onClick={onViewDashboard}>
            View Live Dashboard
          </button>
          {!isAuthenticated ? (
            <button type="button" className="landing-tertiary-button" onClick={onLogin}>
              Log In
            </button>
          ) : null}
        </div>
      </div>

      <div className="landing-hero-visual">
        <SpikeStatsCard />
      </div>
    </section>
  );
}
